import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Text,
  Paper,
  Stack,
  Table,
  Button,
  TextInput,
  Skeleton,
} from '@mantine/core';
import { IconSearch, IconBarcode } from '@tabler/icons-react';
import PageHeader from '@/components/PageHeader';
import EmptyState from '@/components/EmptyState';
import { useProducts } from '@/hooks/usePortalApi';

export default function ProductLabels() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const { data, isLoading } = useProducts({ search: search || undefined, limit: 50 });

  const products = data?.items ?? [];

  return (
    <Stack gap="lg">
      <PageHeader
        title="Product Labels"
        description="View and print scannable product labels with barcodes"
      />

      <TextInput
        placeholder="Search products by name or SKU..."
        leftSection={<IconSearch size={16} />}
        value={search}
        onChange={(e) => setSearch(e.currentTarget.value)}
      />

      {isLoading ? (
        <Stack gap="sm">
          {[...Array(5)].map((_, i) => (
            <Skeleton key={i} height={48} />
          ))}
        </Stack>
      ) : products.length === 0 ? (
        <EmptyState
          title="No products found"
          description={search ? 'Try a different search term.' : 'No products in the catalog yet.'}
        />
      ) : (
        <Paper>
          <Table striped highlightOnHover>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Product Name</Table.Th>
                <Table.Th>SKU</Table.Th>
                <Table.Th>Category</Table.Th>
                <Table.Th ta="right">Actions</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {products.map((p) => (
                <Table.Tr key={p.id}>
                  <Table.Td>
                    <Text size="sm" fw={500}>{p.name}</Text>
                  </Table.Td>
                  <Table.Td>
                    <Text size="sm" c="dimmed">{p.sku}</Text>
                  </Table.Td>
                  <Table.Td>
                    <Text size="sm" tt="capitalize">{p.category}</Text>
                  </Table.Td>
                  <Table.Td ta="right">
                    <Button
                      size="xs"
                      variant="light"
                      leftSection={<IconBarcode size={14} />}
                      onClick={() => navigate(`/labels/${p.id}`)}
                    >
                      View Label
                    </Button>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Paper>
      )}
    </Stack>
  );
}
